import { render, staticRenderFns } from "./ListPlan.vue?vue&type=template&id=71bed9af&scoped=true&"
import script from "./ListPlan.vue?vue&type=script&lang=ts&"
export * from "./ListPlan.vue?vue&type=script&lang=ts&"
import style0 from "./ListPlan.vue?vue&type=style&index=0&id=71bed9af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bed9af",
  null
  
)

export default component.exports